export default [
  {
    name: 'Risk Assessment and Treatment',
    controlsTotal: 1,
    compliantControlsTotal: 0
  },
  {
    name: 'Security Policy',
    controlsTotal: 3,
    compliantControlsTotal: 0
  },
  {
    name: 'Organizational Security',
    controlsTotal: 4,
    compliantControlsTotal: 0
  },
  {
    name: 'Asset Management',
    controlsTotal: 3,
    compliantControlsTotal: 0
  },
  {
    name: 'Human Resource Security',
    controlsTotal: 6,
    compliantControlsTotal: 0
  },
  {
    name: 'Physical and Environmental Security',
    controlsTotal: 2,
    compliantControlsTotal: 0
  },
  {
    name: 'Communications and Operations Management',
    controlsTotal: 15,
    compliantControlsTotal: 0
  },
  {
    name: 'Access Control',
    controlsTotal: 5,
    compliantControlsTotal: 0
  },
  {
    name: 'Information Systems Acquisition Development & Maintenance',
    controlsTotal: 5,
    compliantControlsTotal: 0
  },
  {
    name: 'Incident Event and Communications Management',
    controlsTotal: 2,
    compliantControlsTotal: 0
  },
  {
    name: 'Business Continuity and Disaster Recovery',
    controlsTotal: 1,
    compliantControlsTotal: 0
  }

]



// WEBPACK FOOTER //
// ./src/components/vendor_assessments/conponents/deafult-categories.js